import { Translate } from '@chipinside/translate'
import { Chip, lighten, List, ListItemButton, ListItemText } from '@mui/material'
import { Theme } from '@mui/material/styles'

import { CategoryFilterProps } from '#/components/AdvancedSearch/types'
import { ItemBadge } from '#/components/AdvancedSearch/View/CategoryBadge'
import { useFarmPlan } from '#/store/ducks/farm'
import Colors from '#/styles/Colors'

export function CategoryFilter({ activeCategory, onSelect, options }: CategoryFilterProps) {
  const { isCowConnect } = useFarmPlan()

  const itemSx = {
    '&.Mui-selected': {
      '&:hover': {
        backgroundColor: (theme: Theme) => lighten(theme.palette.primary.light, 0.85),
      },
      'backgroundColor': (theme: Theme) => lighten(theme.palette.primary.light, 0.9),
      'color': 'primary.main',
    },
    'borderRadius': 2,
    'mr': 2,
    'my': 0.5,
  }

  const totalCount = options.reduce((sum, option) => sum + option.count, 0)

  return (
    <List
      sx={{
        borderRight: '1px solid #e1e1e1',
        display: { sm: 'block', xs: 'none' },
        minWidth: 250,
        overflowY: 'auto',
        py: 0,
      }}
    >
      <ListItemButton selected={!activeCategory} onClick={() => onSelect(null)} sx={itemSx}>
        <ItemBadge color={Colors.searchFilters.all} sx={{ mr: 1.5 }} />
        <ListItemText
          slotProps={{ primary: { sx: { textTransform: 'capitalize' }, variant: 'body2' } }}
          primary={Translate({ messageKey: 'search_filter_all' })}
        />
        <Chip label={totalCount} size="small" />
      </ListItemButton>
      {options
        .filter(option => !(isCowConnect && option.key === 'collars'))
        .map(option => {
          const isActive = activeCategory === option.key

          return (
            <ListItemButton
              key={option.key}
              selected={isActive}
              onClick={() => onSelect(isActive ? null : option.key)}
              sx={itemSx}
            >
              <ItemBadge color={Colors.searchFilters[option.key]} sx={{ mr: 1.5 }} />
              <ListItemText
                slotProps={{ primary: { sx: { textTransform: 'capitalize' }, variant: 'body2' } }}
                primary={option.label}
              />
              <Chip label={option.count} size="small" />
            </ListItemButton>
          )
        })}
    </List>
  )
}
